import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useEffect, useRef, useState } from 'react';
import servicesBg from '../assets/services-bg.webp';

const itemsData = [
  { number: 55, suffix: '+', description: 'Completed Projects' },
  { number: 3, suffix: '+', description: 'Countries Represent' },
  { number: 25, suffix: '+', description: 'Expert Members' },
  { number: 500, suffix: '+', description: 'Happy Customers' },
];

function Counter({ target, suffix, start }) {
  const [count, setCount] = useState(0);
  const frame = useRef();

  useEffect(() => {
    if (!start) return;

    let startTime = null;

    function animate(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const duration = 2000;
      const progressRatio = Math.min(progress / duration, 1);
      const currentCount = Math.floor(progressRatio * target);
      setCount(currentCount);

      if (progress < duration) {
        frame.current = requestAnimationFrame(animate);
      } else {
        setCount(target);
      }
    }

    frame.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame.current);
  }, [start, target]);

  return (
    <Typography variant="h3" sx={{ fontWeight: 700, fontSize: '2.5rem', mb: 1 }}>
      {count}{suffix}
    </Typography>
  );
}

export default function Highlights() {
  const sectionRef = useRef();
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    function handleScroll() {
      if (!sectionRef.current) return;
      const top = sectionRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (top < windowHeight - 100 && !startCount) {
        setStartCount(true);
      }
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // initial check in case already visible
    return () => window.removeEventListener('scroll', handleScroll);
  }, [startCount]);

  return (
    <Box
  id="highlights"
  ref={sectionRef}
  sx={{
    pt: { xs: 4, sm: 8 },
    pb: { xs: 8, sm: 8 },
    color: 'white',
    backgroundImage: `url(${servicesBg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
  }}
>

      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            component="h2"
            sx={{
              display: 'inline-block',
              backgroundColor: '#226AE0',
              color: 'white',
              fontWeight: 600,
              px: 2,
              py: 0.5,
              mb: 2,
              borderRadius: 0.5,
              textTransform: 'uppercase',
              userSelect: 'none',
              cursor: 'default',
              fontFamily:'Rajdhani',
              fontSize:'16px',
            }}
          >
            OUR ACHIEVEMENTS
          </Typography>

          <Typography component="h3" variant="h3" fontFamily={'Rajdhani'} fontWeight={600}>
            Deliver agile business solutions using data science,
            machine learning and artificial intelligence technologies for you.
          </Typography>
        </Box>

        <Grid container spacing={2} justifyContent="center">
  {itemsData.map((item, index) => (
    <Grid item xs={12} sm={6} md={3} key={index}>
      <Box
        sx={{
          height: '100%',
          width : '17rem',
          px: 3,
          py: 3,
          textAlign: 'center',
          borderRadius: '12px',
          backdropFilter: 'blur(1px)',
          background: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          color: 'white',
          opacity: startCount ? 1 : 0,
          transition: `all 0.8s ease ${index * 0.2}s`,
          '&:hover': {
            transform: 'scale(1.05)',
          },
        }}
      >
        <Counter target={item.number} suffix={item.suffix} start={startCount} />
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, fontFamily: 'Nunito, sans-serif' }}
        >
          {item.description}
        </Typography>
      </Box>
    </Grid>
  ))}
</Grid>

      </Container>
    </Box>
  );
}
